import React from "react";
import Select from "react-select";
import { customStyles } from "../../test";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../../context/security/AuthProvider";
import {
  useActionsInventoryArticles,
  useDispatchInventoryArticles,
  useInventoryArticles,
} from "../../../../context/inventory/InventoryArticlesByWarehouseProvider";
import { formatNumberCOP } from "../../../../utilities/app.utilities";
import { LOADED } from "../../../../api/constant";
import Pagination from "../../../app/atoms/Pagination";
import { types } from "../../../../reducers/inventory/inventoryArticlesReducer";

export const InventoryByWarehouseTab = () => {
  const stateAuth = useAuth();

  const state = useInventoryArticles();

  const dispatch = useDispatchInventoryArticles();

  const actions = useActionsInventoryArticles();

  const { warehouses } = stateAuth.user;

  const { articles, lotes_item_selected, select_article } = state;
  const isRowSelected = (item) =>
    select_article.item_id === item.item_id && select_article.warehouse_id === item.warehouse_id;

  return (
    <div className="row">
      <div className="col-md-6">
        <div style={{ marginTop: "23px" }}>
          <table className="table table-default-app">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Articulo</th>
                <th scope="col">Almacén</th>
                <th scope="col">Und. medida</th>
                <th scope="col">Cant</th>
                <th scope="col">Und. medida principal</th>
                <th scope="col">Cant. Unidad Principal</th>
              </tr>
            </thead>

            <tbody>
              {articles.elements.map((item, i) => {
                return (
                  <tr
                    className={
                      "cursor-pointer td-hoverme " +
                      (isRowSelected(item) ? " select-article" : "")
                    }
                    onClick={() => {
                      actions.getInventoryItemByLotesUpdated({
                        item_id: item.item_id,
                        warehouse_id: item.warehouse_id,
                        measure_name: item.measure_name,
                      });
                      actions.setFieldArticle(item.item_id, item.warehouse_id);
                    }}
                    key={item.id ?? `row-${item.item_id}-${item.warehouse_id}-${i}`}
                  >
                    <td>{item.code}</td>
                    <td>{item.name}</td>
                    <td>{item.warehouse_code ? `${item.warehouse_code} - ${item.warehouse_name}` : item.warehouse_name ?? "—"}</td>
                    <td>{item.measure_name}</td>
                    <td className="txt-right">{formatNumberCOP(item.stock)}</td>
                    <td>{item.equivalent_name}</td>
                    <td className="txt-right">
                      {formatNumberCOP(item.stock_in_equivalent_measure_main)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end">
          <Pagination
            onChangepage={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_ARTICLES,
                payload: { name: "page", value: e },
              })
            }
            page={articles.filter.page}
            limit={articles.filter.limit}
            rows={articles.rows}
          />
        </div>
      </div>

      {/* **********LOTES DE ARTICULO Y UNIDAD DE MEDIDA*******************+ */}
      {lotes_item_selected.status === LOADED && (
        <div className="col-md-4" style={{ margin: "23px" }}>
          <table className="table table-default-app">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Lote</th>
                <th scope="col">Cant.</th>
                <th scope="col">Fecha vencimiento</th>
              </tr>
            </thead>
            <tbody>
              {lotes_item_selected.items.map((w, index) => {
                return (
                  <tr className="cursor-pointer" key={index}>
                    <td>{w.lote ? w.lote : "N.A"}</td>
                    <td className="txt-right">{formatNumberCOP(w.stock)}</td>
                    <td className="txt-right">
                      {w.date_expired ? w.date_expired : "N.A"}
                    </td>
                  </tr>
                );
              })}

              <tr
                style={{
                  backgroundColor: "#bbbbbb",
                  borderBottomRightRadius: "12px",
                }}
              >
                <td className="font1" colSpan={2}>
                  <div
                    style={{ width: "100%", justifyContent: "space-between" }}
                    className="flex"
                  >
                    Total
                    <span className="txt-right">
                      {formatNumberCOP(
                        actions.getTotalDetail(lotes_item_selected.items)
                      )}
                    </span>
                  </div>
                </td>
                <td className="font1" colSpan={2}>
                  <div
                    style={{ width: "100%", justifyContent: "space-between" }}
                    className="flex"
                  >
                    Und. Medida
                    <span className="txt-right">
                      {lotes_item_selected.measure_name}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* **********LOTES DE ARTICULO Y UNIDAD DE MEDIDA*******************+ */}
    </div>
  );
};
